export default (context) => {
  return {
    config: {
      pageSize: 20,
      list: false,
      customPathGet: 'admStudent/contacts',
      remap: (r) => {
        r.data.Results.forEach(e => {
          ['depMail', 'rel1mail', 'rel2mail'].forEach(col => {
            e[`isChecked_${col}`] = context.state.checkedList.some(c => c.colId === col && c.rowId === e.ID && c.mail === e[col])
          })
        })
        return r
      }
    },
  
    actions: {
      print: false,
      export: context.props.userAdmin.role === '100',
      search: true
    },

    extras: {
      items: [
        { id: 1, icon: 'simple-icon-envelope-open', name: 'Enviar correo', onClick: () => {
            let openPopupCentered = (url,width,height) => {
              var x=(window.screen.width/2)-(width/2);
              var y=(window.screen.height/2)-(height/2);
              window.open(url, 'popup', 'width=' + width + ', height=' + height + ', left=' + x + ', top=' + y +'');
            }
            let url = 'https://mail.google.com/mail/u/5/?fs=1&bcc='
            context.state.checkedList.forEach(e => {
              url += e.mail + ','
            });
            url = url.slice(0, -1)
            url += '&tf=cm'
            // console.log(url)
            openPopupCentered(url, 800, 600)
          } 
        },
      ]
    },

    filter: {
      fields: [
        {
          name: "studentId",
          value: 0,
          type: "select",
          label: "Alumno",
          opts: {
            style: 'float-label',
            searchOnline: true,
            path: "/admStudent/get?enrolled=-1&active=-1&pick=true",
            withImg: true
          },
          onChange: (ctx) => {
            ctx.setState({sectionId: 0 })
          }
        },
        {
          name: "sectionId",
          value: 0,
          type: "select",
          label: "Sección",
          opts: {
            style: 'float-label',
            searchOnline: true,
            path: "/admSection/get?pick=true"
          },
          onChange: (ctx) => {
            ctx.setState({studentId: 0 })
          }
        }
      ],
      buttons: [
        {
          label: 'Aplicar filtro',
          renderIf: (ctx) => { return Number.isInteger(ctx.state.studentId) || Number.isInteger(ctx.state.sectionId)},
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      fields: [
        {
          col: 12,
          name: "ID",
          value: null,
          type: "text",
          label: "ID",
          disabled: true,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "easyId",
          value: "",
          type: "text",
          label: "Número de documento",
          rules: 'required',
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 6,
          name: "externalId",
          value: null,
          type: "text",
          label: "Código externo",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "total",
          value: null,
          type: "text",
          label: "Monto",
          disabled: true,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "paid",
          value: false,
          type: "switch",
          label: "Pagado",
          disabled: true,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "brief",
          value: "",
          type: "text",
          label: "Concepto",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "curr",
          value: null,
          type: "text",
          label: "Moneda",
          disabled: true,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "dueDate",
          value: null,
          type: "date",
          label: "Vencimiento",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "created",
          value: null,
          type: "date",
          label: "Fecha creación",
          disabled: true,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "hasPenalty",
          value: false,
          type: "switch",
          label: "Penalidad",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "principalName",
          value: null,
          type: "text",
          label: "Nombre responsable",
          rules: 'required',
          disabled:true,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "dependantName",
          value: null,
          type: "text",
          label: "Nombre dependiente",
          rules: 'required',
          disabled:true,
          opts: {
            style: 'float-label'
          }
        }
      ]
    },

    columns: [
      {
        Header: "ID",
        accessor: "ID"
      },
      {
        Header: "Nombre",
        accessor: "name"
      },
      {
        Header: "Apellido paterno",
        accessor: "last"
      },
      {
        Header: "Apellido materno",
        accessor: "last2"
      },
      {
        Header: "Código",
        accessor: "externalId"
      },
      {
        Header: "Padre",
        accessor: "rel1"
      },
      {
        Header: "Tel. Padre",
        accessor: "rel1Tel"
      },
      {
        Header: "Madre",
        accessor: "rel2"
      },
      {
        Header: "Tel. Madre",
        accessor: "rel2Tel"
      },
      {
        Header: "Mail padre",
        accessor: "rel1mail",
        type: 'check',
        id: 'parent',
        minWidth: 50,
        classList: "w-sm-100"
      },
      {
        Header: "Mail madre",
        accessor: "rel2mail",
        type: 'check',
        id: 'mother',
        minWidth: 50,
        classList: "w-sm-100"
      },
      {
        Header: "Mail alumno",
        accessor: "depMail",
        type: 'check',
        id: 'pupil',
        minWidth: 50,
        classList: "w-sm-100"
      }
    ]
  } 
}